import deliveryModesServiceGen from "./generated/deliveryModesServiceGen";

class deliveryModesService extends deliveryModesServiceGen {
}

export default deliveryModesService;